import apiService from "../utils/apiInterceptor";

// Email Service - outbound test email API calls
export const emailService = {
  sendTestEmail: async (emailData) => {
    try {
      return await apiService.post("/api/email/send-email", emailData);
    } catch (error) {
      throw error;
    }
  },
};

export default emailService;
